import React from "react";
import Modal from "../../Layout/Modal";
import { useEffect, useState } from "react";
import { getFeatureBySubCategory } from "../../../Services/FeatureService";

const ModalFormFeature = ({
  sub_sub_category,
  modalId10,
  onCloseModal4,
  reqFeature,
  totScoreFeature,
  onSaveFeature,
  disableAll = false,
}) => {
  // {
  //     console.log(reqFeature);
  // }

  const [localReq, setLocalReq] = useState([]);
  const [flag, setflag] = useState(0);
  const [totalScoreLocal, settotalScoreLocal] = useState(0);
  const [productClass, setProductClass] = useState("");

  useEffect(() => {
    const newArr = [];
    reqFeature.forEach((elem) => {
      const newElem = {
        ...elem,
      };
      newArr.push(newElem);
    });
    setLocalReq(newArr);
  }, [reqFeature, flag]);

  useEffect(() => {
    settotalScoreLocal(totScoreFeature);
    if (totScoreFeature >= sub_sub_category?.best) {
      setProductClass("BEST");
    } else if (totScoreFeature >= sub_sub_category?.better) {
      setProductClass("BETTER");
    } else if (totScoreFeature >= sub_sub_category?.good) {
      setProductClass("GOOD");
    } else {
      setProductClass("");
    }
  }, [totScoreFeature]);

  const setValue = (name, value) => {
    setProductClass(value);
  };

  ////////ON CHANGE/////////////
  const onChangeFormFeatureLocal = (feature, i, e) => {
    const _reqFeature = localReq.map((item) => {
      return item;
    });

    if (e.target[e.target.selectedIndex].id >= 0 && e.target.value != "") {
      const indexFeature = e.target[e.target.selectedIndex].id;

      _reqFeature[i].score = feature[indexFeature].score;
      _reqFeature[i].id_feature_type = feature[indexFeature].id;

      const _totScoreFeature = _reqFeature.reduce(
        (previousValue, currentValue) => {
          return previousValue + currentValue.score;
        },
        0
      );

      if (_totScoreFeature >= sub_sub_category?.best) {
        setProductClass("BEST");
      } else if (_totScoreFeature >= sub_sub_category?.better) {
        setProductClass("BETTER");
      } else if (_totScoreFeature >= sub_sub_category?.good) {
        setProductClass("GOOD");
      } else {
        setProductClass("");
      }
      setLocalReq(_reqFeature);
      settotalScoreLocal(_totScoreFeature);
    } else {
      console.log("masuk else");

      _reqFeature[i].score = 0;
      _reqFeature[i].id_feature_type = null;

      const _totScoreFeature = _reqFeature.reduce(
        (previousValue, currentValue) => {
          return previousValue + currentValue.score;
        },
        0
      );

      if (_totScoreFeature >= sub_sub_category?.best) {
        setProductClass("BEST");
      } else if (_totScoreFeature >= sub_sub_category?.better) {
        setProductClass("BETTER");
      } else if (_totScoreFeature >= sub_sub_category?.good) {
        setProductClass("GOOD");
      } else {
        setProductClass("");
      }
      setLocalReq(_reqFeature);
      settotalScoreLocal(_totScoreFeature);
    }
  };

  const handleSave = () => {
    onSaveFeature(localReq, totalScoreLocal, productClass);
  };

  const handleClose = () => {
    setLocalReq(reqFeature);
    settotalScoreLocal(totScoreFeature);
    if (totScoreFeature >= 30) {
      const product_class = "BEST";
      setValue("product_class", product_class);
    } else if (totScoreFeature >= 20 && totScoreFeature <= 29) {
      const product_class = "BETTER";
      setValue("product_class", product_class);
    } else if (totScoreFeature < 20) {
      const product_class = "GOOD";
      setValue("product_class", product_class);
    } else if (totScoreFeature == 0) {
      const product_class = "";
      setValue("product_class", product_class);
    }
    setflag(flag + 1);
    onCloseModal4();
  };

  return (
    <Modal
      id={modalId10}
      title="Select Features"
      onClose={handleClose}
      onAction={handleSave}
      btnActionName="Save Feature"
      modalSize="modal-lg"
      btnActionDisabled={disableAll}
    >
      <div className="col-md-10">
        {localReq.map((ftr, i) => (
          <div key={`key-unique-${i}`}>
            {ftr.status && (
              <div className="row">
                <div className="col-md-5">
                  <div className="form-group">
                    <label key={`lbl-` + i}>{ftr.feature_name}</label>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) =>
                        onChangeFormFeatureLocal(ftr.detail, i, e)
                      }
                      value={
                        ftr.id_feature_type === null ||
                        ftr.id_feature_type === undefined
                          ? ""
                          : ftr.id_feature_type
                      }
                    >
                      <option value={""}>Select Feature Detail</option>
                      {ftr.detail.map((elem, j) => (
                        <option key={`opt-` + j} id={j} value={elem.id}>
                          {elem.type_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <input
                      key={`score-` + i}
                      id={`score-` + i}
                      name={`score-` + i}
                      placeholder="score"
                      value={ftr.score > 0 ? ftr.score : 0}
                      className="form-control"
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        <div className="row">
          <div className="col-md-10">
            <div className="form-group">
              <label>Total Feature Score</label>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <input
                name="total_score"
                value={totalScoreLocal}
                className="form-control"
                readOnly={true}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalFormFeature;
